import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { getClientMailingListsQueryKey } from './get-client-mailing-lists'

type UpdateMailingListSubscriptionRequest = {
  subscribe: number[]
}

const updateMailingListSubscription = async (
  clientId: string,
  data: UpdateMailingListSubscriptionRequest,
): Promise<void> => {
  await authAPI.post(`/mailinglist/client/${clientId}`, data)
}

export const useUpdateMailingListSubscription = (clientId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateMailingListSubscriptionRequest) =>
      updateMailingListSubscription(clientId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getClientMailingListsQueryKey({ clientId }) })
    },
  })
}
